import type { Interpolation } from '@emotion/react';
import { css } from '@emotion/react';

import * as React from 'react';

import useRouter from 'js/lib/useRouter';

import { Typography } from '@coursera/cds-core';
import type { IconProps, Theme } from '@coursera/cds-core';

import { onClickNavUrl } from 'bundles/cds-labs/components/Modules/utils/utm';
import type { BlockLevelModule } from 'bundles/ent-website/contentful/core/Module';
import { eventingTransform } from 'bundles/ent-website/utils/eventingTransform';
import isExternalLink from 'bundles/ent-website/utils/isExternalLink';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

type Props = {
  href: string;
  text: string;
  module: BlockLevelModule;
  position: number;
  typographyColor?:
    | 'inherit'
    | 'error'
    | 'body'
    | 'invertBody'
    | 'supportText'
    | 'primaryHeadline'
    | 'success'
    | 'highlightBlue'
    | 'highlightPurple'
    | 'eyebrowYellow'
    | 'eyebrowAqua'
    | 'eyebrowPurple'
    | undefined;
  icon?: JSX.Element;
  namespace?: string;
};

const styles: Record<string, Interpolation<Theme>> = {
  link: () => css`
    display: inline-flex;
    align-items: center;
    text-decoration: underline;
  `,
};

const ContentfulLink = ({ href, text, module, position, typographyColor, icon, namespace }: Props) => {
  const target = isExternalLink(href) ? '_blank' : '_self';
  const rel = isExternalLink(href) ? 'noopener noreferrer' : '';
  const trackingName = eventingTransform(`${module.__typename}_${module.slug}_${namespace || 'link'}_${position}`);
  const router = useRouter();

  if (typographyColor) {
    return (
      <TrackedA href={href} onClick={onClickNavUrl(router, href)} trackingName={trackingName} rel={rel} target={target}>
        <Typography color={typographyColor} display="inline" variant="inherit" css={styles.link}>
          {text}
          {icon && icon}
        </Typography>
      </TrackedA>
    );
  }
  return (
    <TrackedA href={href} onClick={onClickNavUrl(router, href)} trackingName={trackingName} rel={rel} target={target}>
      {text}
    </TrackedA>
  );
};

export default ContentfulLink;
